import React from "react";
import "./Testimonial.css";

const testimonials = [
  {
    name: "John Doe",
    rating: 5,
    text: "This is an amazing product. Totally worth the money!",
  },
  {
    name: "Jane Smith",
    rating: 5,
    text: "Excellent service and quality. Will recommend to everyone.",
  },
  {
    name: "Alex Johnson",
    rating: 4,
    text: "Very good experience. Just one small issue, otherwise perfect!",
  },
  {
    name: "Emily Clark",
    rating: 5,
    text: "Absolutely love it. The support team is awesome!",
  },
  {
    name: "Michael Lee",
    rating: 5,
    text: "Using it for months and it never disappoints.",
  },
];

const TestimonialsCarousel = () => {
  return (
    <div className="carousel-container">
      <h2 className="carousel-title">Loved by people worldwide</h2>
      <div className="carousel-wrapper">
        <div className="carousel-track">
          {[...testimonials, ...testimonials].map((t, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-header">
                <div className="avatar"></div>
                <div className="name">{t.name}</div>
              </div>
              <div className="stars">
                {"★".repeat(t.rating)}{"☆".repeat(5 - t.rating)}
              </div>
              <p className="testimonial-text">{t.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialsCarousel;
